<template>
  <div class="user-info">
    <div class="title">个人资料</div>
    <div class="content">
      <div class="item">
        <div class="item-left">头像</div>
        <div class="item-right" @click="openUploadModal(true)">
          <!-- <el-upload
            class="upload-demo"
            :show-file-list="false"
            accept=".png,.jpg,.jpeg,.gif,.PNG,.JPG,.JPEG,.GIF"
            :headers="headers"
            :action="uploadUrl"
            :before-upload="handleUploadBefore"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
          > -->
          <img :src="formInfo.staffImage || defaultImgNew" alt="" />
          <!-- <i class="iconfont icon-a-Group5058"></i> -->
          <SvgIcon icon-class="a-Group5058" class-name="icon-a-Group5058" />
          <!-- </el-upload> -->
          <!-- <div class="icon-camera-mask">
            <img src="@/assets/icon-camera.png" alt="" />
          </div> -->
        </div>
      </div>
      <div class="item">
        <div class="item-left">工号</div>
        <div class="item-right">{{ formInfo.jobNumber || "-" }}</div>
      </div>
      <div class="item">
        <div class="item-left">花名</div>
        <div class="item-right">{{ formInfo.flowerName || "-" }}</div>
      </div>
      <div class="item">
        <div class="item-left">姓名</div>
        <div class="item-right">{{ formInfo.staffName || "-" }}</div>
      </div>
      <div class="item">
        <div class="item-left">性别</div>
        <div class="item-right">{{ formInfo.sex || "-" }}</div>
      </div>
      <div class="item">
        <div class="item-left">工作地点</div>
        <div class="item-right">{{ enumWorkPlace[formInfo.workPlace] || "-" }}</div>
      </div>
      <div class="item">
        <div class="item-left">公司</div>
        <div class="item-right">{{ formInfo.company || "-" }}</div>
      </div>
      <div class="item">
        <div class="item-left">组织</div>
        <div class="item-right">{{ formInfo.organizeName || "-" }}</div>
      </div>
      <div class="item">
        <div class="item-left">组织路径</div>
        <div class="item-right">{{ formInfo.organizePath || "-" }}</div>
      </div>
      <div class="item">
        <div class="item-left">岗位名称</div>
        <div class="item-right">{{ formInfo.postName || "-" }}</div>
      </div>
      <div class="item">
        <div class="item-left">手机号码</div>
        <div class="item-right">{{ formInfo.phone || "-" }}</div>
      </div>
      <div class="item">
        <div class="item-left">企业邮箱</div>
        <div class="item-right">{{ formInfo.email || "-" }}</div>
      </div>
      <div class="item">
        <div class="item-left">入职时间</div>
        <div class="item-right">{{ formInfo.entryDate || "-" }}</div>
      </div>
    </div>
    <UploadImgModal ref="uploadImgModal" @changeHeaderImage="changeHeaderImage" />
  </div>
</template>

<script>
import { apiStaffGetStaffInfo, apiStaffStaffImage } from "@/api/user"
import { getToken } from "@/utils/auth"
import dayjs from "dayjs"
import UploadImgModal from "./UploadImgModal.vue"

const baseUrl = process.env.NODE_ENV === "development" ? "" : process.env.VUE_APP_BASE_API
const defaultImgNew = "https://test-static.tfeimall.com/src/menu/menuIcon_8043f5dd-430e-47c8-874e-6342e0230fce_1723713852035.png"
export default {
  name: "UserInfo",
  components: {
    UploadImgModal
  },
  data() {
    this.headers = { Authorization: getToken(), "X-ct-sso": getToken() }
    return {
      uploadUrl: `${baseUrl}/api/mds/oss/upload`,
      formInfo: {},
      enumWorkPlace: {
        2: "深圳",
        3: "西安",
        4: "上海"
      },
      defaultImgNew
    }
  },
  created() {
    this.getStaffInfo()
  },
  methods: {
    changeHeaderImage(imgUrl) {
      this.formInfo.staffImage = imgUrl
      this.$emit("changeHeaderImage", imgUrl)
    },
    async getStaffInfo() {
      const { code, data } = await apiStaffGetStaffInfo()
      if (code != 0) return
      this.formInfo = { ...data, entryDate: dayjs(data.entryDate).format("YYYY-MM-DD") }
      this.$emit("changeHeaderImage", data.staffImage)
      this.$nextTick(() => {
        this.openUploadModal(false)
      })
    },
    // 上传之前校验文件大小
    handleUploadBefore(file) {
      this.loading = true
      const number = 20
      const isLt2M = file.size / 1024 / 1024 < number
      if (!isLt2M) {
        this.$message.warning(`图片大小不能超过 ${number}MB!`)
        this.loading = false
        return false
      }
    },
    // 上传失败
    handleUploadError(err, file, fileList) {
      if (err) console.log(err)
      this.$message.warning("上传出错, 请稍后再试")
    },
    // 上传成功
    async handleUploadSuccess(response, file, fileList) {
      if (response.code != 0) return
      const { code } = await apiStaffStaffImage({ staffImage: response.data.url })
      if (code != 0) return this.$message.error("修改头像失败")
      this.formInfo.staffImage = response.data.url
      this.$emit("changeHeaderImage", response.data.url)
    },
    openUploadModal(isShow = true) {
      this.$refs.uploadImgModal?.show(
        {
          imgUrl:
            this.formInfo.staffImage.indexOf("hulk/other_page_icons/Group") === -1
              ? this.formInfo.staffImage
              : require("@/assets/icon-group.png") || this.defaultImgNew
        },
        isShow
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.user-info {
  width: 100%;
  height: 100%;
  padding: 24px 0 0 24px;
  display: flex;
  flex-direction: column;

  .title {
    font-weight: bold;
    font-size: 16px;
    color: #333333;
    line-height: 19px;
  }

  .content {
    margin-top: 12px;
    flex: 1;
    overflow-y: hidden;

    .item {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 24px;
      }

      .item-left {
        width: 56px;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: #999999;
        text-align: right;
      }

      .item-right {
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        margin-left: 16px;
        position: relative;

        img {
          width: 60px;
          height: 60px;
          border-radius: 4px 4px 4px 4px;
          object-fit: cover;
          cursor: pointer;
          //   border: 1px solid #e7e9ec;
        }
      }
    }
  }
}

.icon-a-Group5058 {
  // opacity: 0.6;
  position: absolute;
  right: 4px;
  bottom: 8px;
  cursor: pointer;
}
</style>
